'use strict';

module.exports = {
    ERROR: 'ERROR',
    WARNING: 'WARNING',
};
